import { Controller } from '../utils/controller';

export default class SelectList extends Controller {
  static targets = ['icon', 'item', 'list', 'title'];
  static requiredTargets = [];

  static classes = ['closed', 'closedIcon'];
  static requiredClasses = [];

  static values = {
    isOpen: {
      type: Boolean,
      default: false
    },
    closeListOnItemSelect: {
      default: true,
      type: Boolean
    }
  };

  // TARGETS
  declare iconTarget: HTMLElement;
  declare listTarget: HTMLDivElement;
  declare readonly hasIconTarget: boolean;
  declare readonly hasListTarget: boolean;
  declare readonly hasTitleTarget: boolean;
  declare titleTarget: HTMLDivElement;

  //VALUES
  declare closeListOnItemSelectValue: boolean;
  declare isOpenValue: boolean;

  //CLASSES
  declare closedClass: string;
  declare closedIconClass: string;

  close(event) {
    if (this.hasListTarget && this.listTarget.contains(event.relatedTarget)) {
      event.relatedTarget.click();
    }

    this.isOpenValue = false;
  }

  handleSkuChangeEvent(event) {
    const id = event?.detail?.sku?.id;
    const element = this.element.querySelector(`[data-select-list-id-param="${id}"]`);

    if (element == null) {
      return;
    }

    this.setTitle(element.innerHTML);
  }

  handleItemSelect(event) {
    if (!event?.target?.innerHTML) {
      return;
    }

    this.setTitle(event.target.innerHTML);

    if (this.closeListOnItemSelectValue) {
      this.close(event);
    }
  }

  isOpenValueChanged() {
    this.render();
  }

  render() {
    this.setVisibility(this.isOpenValue);
  }

  setTitle(title) {
    if (this.hasTitleTarget) {
      this.titleTarget.innerHTML = title;
    }
  }

  setVisibility(isOpen) {
    if (this.hasListTarget) {
      this.listTarget.classList.toggle(this.closedClass, !isOpen);
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle(this.closedIconClass, !isOpen);
    }
  }

  toggle() {
    this.isOpenValue = !this.isOpenValue;
  }
}
